import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { Emoji } from 'emoji-mart';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { listify } from 'Helpers/Utils';

const useStyles = buildUseStyles('ReactionTooltip', () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
}));

const ReactionTooltip = ({
  className,
  emoji,
  owners,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <Emoji emoji={emoji} size={64} />
      <Typography color={'mediumDarkGray'}>
        <Typography display={'inline'} color="white">
          {listify(owners)}
        </Typography>
        {` reacted with ${emoji}`}
      </Typography>
    </Box>
  );
};

ReactionTooltip.defaultProps = {
  className: '',
};

ReactionTooltip.propTypes = {
  className: PropTypes.string,
  emoji: PropTypes.string.isRequired,
  owners: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export { ReactionTooltip };
